var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.55,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    d: "M37.82 14.14H10.18A3.18 3.18 0 0 0 7 17.32v19.06a3.18 3.18 0 0 0 3.18 3.18h27.64A3.18 3.18 0 0 0 41 36.38V17.32a3.18 3.18 0 0 0-3.18-3.18ZM30 14.14v-.29A5.85 5.85 0 0 0 24.18 8a5.85 5.85 0 0 0-5.85 5.85v.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF7900",
    d: "M27 21.19h-4.18A1.8 1.8 0 0 0 21 23v1.63A1.34 1.34 0 0 0 22.37 26H25a1.94 1.94 0 0 1 2 1.89v.87a2.21 2.21 0 0 1-2.2 2.2H21M23.97 17.81v2.87M23.97 31.61v2.87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 7h36v33.56H6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.cba945ff34a6447518fb22015909a403.svg";
export { ForwardRef as ReactComponent };